module.exports = __webpack_public_path__ + "img/TwitterLogo blue.609a0376.svg";